import { useDialog } from '../../../../../../hooks/use-dialog';

export const useExchangeRateDialog = () => {
  const { isDialogOpen, handleOpen, handleClose } = useDialog();

  return {
    isDialogOpen,
    handleOpenDialog: handleOpen,
    handleCloseDialog: handleClose,
  };
};
